<template>
  <div class="payment-statement-view width-responsiveness">
    <div class="payment-statement-view__content">
      <div class="payment-statement-view__header">
        <img
          src="/static/images/icon-return-arrow.svg"
          alt="busca"
          @click="handleBackButton()"
        >
        <h1>Extrato de {{ mesAno }}</h1>
      </div>

      <Table
        :list="paymentStatementList"
        :columns="examColumns"
        :is-loading-list="isLoadingList"
        :table-size="100"
        @orderBy="orderByProp"
        @clickItem="handleClickItem"
      />

      <Pagination
        :current-page="currentPage"
        :total-pages="totalPages"
        @page-change="handleChangePage"
      />
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import 'moment/locale/pt-br'

import Table from '@/components/common/Table'
import { mapActions } from 'vuex'
import payments from '@/api/payments'
import moment from 'moment'
import Pagination from '../common/Pagination.vue'

export default {
  name: 'PaymentStatementView',
  components: {
    Table,
    Pagination
  },
  beforeRouteLeave(to, from, next) {
    this.cleanPaymentList()
    next()
  },
  data() {
    return {
      isLoadingList: false,
      currentPage: 1,
      totalPages: 0,
      paymentStatementList: [],
      examColumns: [
        { name: 'Data do cadastro', propName: 'registrationDate', widthPercent: 13, textPosition: 'left' },
        { name: 'Tipo', propName: 'type', widthPercent: 30, textPosition: 'left' },
        { name: 'Detalhe', propName: 'details', widthPercent: 10, textPosition: 'left' },
        {
          name: 'Valor total',
          propName: 'value',
          widthPercent: 15,
          textPosition: 'right',
          valueType: 'R$'
        }
      ]
    }
  },
  computed: {
    mesAno() {
      Moment.locale('pt-br')
      return Moment().locale('pt-br').format('MMMM YYYY')
    }
  },
  mounted() {
    this.fetchPaymentStatementList()
  },
  methods: {
    ...mapActions(['cleanPaymentList']),
    handleBackButton() {
      this.$router.go(-1)
    },
    handleClickItem({details}) {
      this.$router.push(`/traceability/search?q=${details}&typeOfSearch=OA`)
    },
    handleChangePage(page) {
      this.currentPage = page
      this.fetchPaymentStatementList()
    },
    orderByProp(data) {
      if (data) {
        const { column, sortType } = data
        const sortedList = [...this.paymentStatementList].sort((a, b) => {
          const valueA = a[column]
          const valueB = b[column]

          const isNumericA = !isNaN(parseFloat(valueA)) && isFinite(valueA)
          const isNumericB = !isNaN(parseFloat(valueB)) && isFinite(valueB)

          if (isNumericA && isNumericB) return sortType === 'asc' ? valueA - valueB : valueB - valueA
          else if (isNumericA) return sortType === 'asc' ? -1 : 1
          else if (isNumericB) return sortType === 'asc' ? 1 : -1
          else return sortType === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        })
        this.paymentStatementList = sortedList
      }
    },
    fetchPaymentStatementList() {
      this.isLoadingList = true

      payments
        .getPaymentStatement('PREPAID', { page: this.currentPage - 1, size: 15 })
        .then(response => {
          const { content, totalPages } = response.data

          this.totalPages = totalPages
          this.paymentStatementList = content.map(item => {
            return {
              registrationDate: moment(item.registrationDate).format('DD/MM/YYYY'),
              type: item.type,
              details: item.details,
              amount: item.amount,
              value: item.value
            }
          })
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.isLoadingList = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../static/stylesheets/variables';

  .payment-statement-view {
    min-height: 100vh;
    padding-top: $mainHeaderHeight;
    padding-bottom: 30px;
    margin-top: 3em;
    font-family: 'Exo 2' !important;

    &__header {
      display: flex;
      align-items: center;
      color: #6d6d6d;
      gap: 15px;
      align-items: center;
      margin-bottom: 24px;

      h1 {
        font-size: 22px;
      }
    }
  }
</style>
